// Smart Sash Admin Panel - Card Component

import React from 'react';

export interface CardProps {
  title?: string;
  subtitle?: string;
  headerActions?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  children?: React.ReactNode;
}

/**
 * Reusable Card Component
 * Wraps Bootstrap card with common patterns
 */
export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  headerActions,
  footer,
  className = '',
  bodyClassName = '',
  children
}) => {
  const hasHeader = title || subtitle || headerActions;

  return (
    <div className={`card ${className}`}>
      {hasHeader && (
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              {title && <h5 className="card-title mb-0">{title}</h5>}
              {subtitle && <p className="card-subtitle text-muted mb-0 mt-1">{subtitle}</p>}
            </div>
            {headerActions && <div>{headerActions}</div>}
          </div>
        </div>
      )}
      <div className={`card-body ${bodyClassName}`}>
        {children}
      </div>
      {footer && (
        <div className="card-footer">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
